/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Modify the loading state
 *
 * @param  {Object} state
 * @return {Void}
 */
const SET_LOADING = state => {
    state.loading = true
}

/**
 * Modify the loading state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_LOADING = state => {
    state.loading = false
}

/**
 * Set the importer payload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const SET_DATA = (state, payload) => {
    state.data = payload
}

/**
 * Set the importer payload errors
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const SET_DATA_ERROR = (state, errors) => {
    state.errors = errors
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = state => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Update the active tab state
 *
 * @param  {Object} state
 * @param  {String} tab
 * @return {Void}
 */
const UPDATE_TAB = (state, tab) => {
    state.activeTab = tab
    state.selectedCategory = ''
    state.searchTerm = ''
}

/**
 * Change the selected category state
 *
 * @param  {Object} state
 * @param  {String} category
 * @return {Void}
 */
const UPDATE_SELECTED_CATEGORY = (state, payload) => {
    state.selectedCategory = payload.cat
    state.selectedColorIndex = payload.idx
    state.searchTerm = null
}

/**
 * Update an item's category
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const UPDATE_ITEM_CATEGORY = (state, payload) => {
    let item = state.data[state.activeTab].find(item => item.id === payload.id)

    item.our_category = payload.category === 'Excluded Items'
        ? null
        : payload.category
}

/**
 * Update the search term
 *
 * @param  {Object} state
 * @param  {String} term
 * @return {Void}
 */
const UPDATE_SEARCH_TERM = (state, term) => {
    state.searchTerm = term
}

/**
 * Handle the successful import
 *
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
const IMPORT_SUCCESSFUL = state => {
    state.success = true
}

/**
 * Handle the failed import
 *
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
const IMPORT_FAILED = (state, err) => {
    state.error = true
}

/**
 * Handle a successful request for assistance on a failed file upload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
const SUPPORT_REQUEST_SUCCESS = (state, message) => {
    state.helpRequested = true
    state.requestingHelp = false
    state.assistanceMessage = message
}

/**
 * Handle a failed request for assistance on a failed file upload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
const SUPPORT_REQUEST_FAILURE = (state, error) => {
    state.helpRequested = true
    state.requestingHelp = false
}

/**
 * Set the loading indicator
 *
 * @param  {Object} state
 * @return {Promise}
 */
const REQUEST_FILE_ASSISTANCE = state => {
    state.requestingHelp = true
}

/**
 * Toggle the tree tablem
 *
 * @param  {Object} state
 * @return {Void}
 */
const TOGGLE_INPUT_BINDINGS = state => {
    state.showInputBindings = !state.showInputBindings
}

export default {
    SET_DATA,
    UPDATE_TAB,
    RESET_STATE,
    SET_LOADING,
    RESET_LOADING,
    IMPORT_FAILED,
    SET_DATA_ERROR,
    IMPORT_SUCCESSFUL,
    UPDATE_SEARCH_TERM,
    UPDATE_ITEM_CATEGORY,
    TOGGLE_INPUT_BINDINGS,
    REQUEST_FILE_ASSISTANCE,
    SUPPORT_REQUEST_SUCCESS,
    SUPPORT_REQUEST_FAILURE,
    UPDATE_SELECTED_CATEGORY
}



// WEBPACK FOOTER //
// ./src/state/modules/pnl-importer/mutations.js